const popArrowSvg = '<svg class="pop-arrow" width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M9.88326 12.9173L9.88327 12.9177C9.89143 13.1844 9.98336 13.4133 10.1634 13.5934C10.3447 13.7746 10.5755 13.8629 10.8437 13.8629C11.1118 13.8629 11.3427 13.7746 11.524 13.5934L16.938 8.17931C17.0335 8.08386 17.1049 7.97666 17.1478 7.85745L17.1481 7.85673C17.1881 7.74374 17.2075 7.62414 17.2075 7.49902C17.2075 7.37385 17.1881 7.25189 17.1491 7.13376L17.1488 7.13285C17.1064 7.00688 17.0342 6.89975 16.9335 6.81419L11.524 1.40468C11.3427 1.22341 11.1118 1.13516 10.8437 1.13516C10.5755 1.13516 10.3447 1.22341 10.1634 1.40468C9.98336 1.5847 9.89143 1.81366 9.88327 2.08037L9.88326 2.08073C9.87566 2.35011 9.96043 2.5828 10.1429 2.76525L13.9131 6.53542L2.0044 6.76113C1.73491 6.76147 1.50176 6.85429 1.31509 7.04031L1.31473 7.04068C1.12837 7.22768 1.03555 7.46133 1.03555 7.73144C1.03555 8.00156 1.12838 8.23505 1.31491 8.42157C1.50188 8.60854 1.73558 8.70176 2.00586 8.70178L2.0087 8.70173L13.8993 8.47636L10.1429 12.2328C9.96043 12.4152 9.87566 12.6479 9.88326 12.9173Z" fill="#fff" stroke="#5E3654" stroke-width="0.3"/> </svg>';

// Parameters and keys 
let key = document.cookie.split('; ').find((row) => row.startsWith('_shopify_s='))?.split('=')[1];
let parameters = '?shop=' + Shopify.shop + '&key=' + key;

// get available coins API
const brandAPI = `https://prodreplica.mypopcoins.com/api/get-brand?shop=${Shopify.shop}`;
const coinsAPI = `https://prodreplica.mypopcoins.com/api/get-available-coins${parameters}`;
const lottieAnimation = '<div class="popcoins-lottie-animation"><span id="n">N</span><span id="e">E</span><span id="w">W</span></div>';
const rewardNameLottieAnimationLink = `TruMoms Rewards <div class="popcoins-lottie-animation"><span id="n">N</span><span id="e">E</span><span id="w">W</span></div>`;
// Popclub Elements 
const loginFlag = document.querySelector("#pop-club-login-flag");
const redeemPrice = document.querySelector("#pop-club-redeem-price");
const dataRedeem = document.querySelector("#pop-club-data-redeem");
const popBalance = document.querySelector("#pop-club-data-coins");

var popIconAPI = 'https://ecomapp-dev-v2.s3.ap-south-1.amazonaws.com/Coin.png', popIcon = '<img src="https://ecomapp-dev-v2.s3.ap-south-1.amazonaws.com/Coin.png" height="23px" width="23px" alt="POPcoins Logo">';

// Brand & fetch coin API Calls 
const getBrandInfo = async () => {
  try {
    const [P1, P2] = await Promise.all([fetch(brandAPI), fetch(coinsAPI)])
    const brand_data = await P1.json();
    const coin_data = await P2.json();
    redeemPrice.value = brand_data.issuance;
    dataRedeem.value = brand_data.redeem;
    loginFlag.value = coin_data.success;
    popBalance.value = coin_data.coins;

    popIconAPI = brand_data.popcoins_icon;
    popIcon = `<img src="${popIconAPI}" height="23px" width="23px" alt="POPcoins Logo">`;

    sessionStorage.setItem('popMaxRedeem', brand_data.max_discount_per_order);
    sessionStorage.setItem('popMOV', brand_data.minimum_cart_value ? brand_data.minimum_cart_value : 0);

    PDPEarnCall()
    bottomStrip();
    // PDP_BuyNow();
    // PLPCoins();
    let drawerCheckbox = document.getElementById('buy-with-pop-coins-cart-drawer-checkbox');
    if (drawerCheckbox) {
      discount_clear()
      cartEarnCall();
      if (loginFlag.value == 'true') {
        // drawerCheckbox.checked = true;
        drawerCheckbox.addEventListener('change', function () {
          cartEarnCall();
          if (this.checked == true) {
            customCartCheckout();
          } else {
            discount_clear();
          }
        })
      }
    }
    let cartPageCheckBox = document.getElementById('buy-with-pop-coins-cart-page-checkbox')
    if (cartPageCheckBox) {
      discount_clear()
      cartPageEarnCall();
      if (loginFlag.value == 'true') {
        // cartPageCheckBox.checked = true;
        cartPageCheckBox.addEventListener('change', function () {
          cartPageEarnCall();
          if (this.checked == true) {
            customCartCheckout();
          } else {
            discount_clear();
          }
        })
      }
    }
    let clickPopBuynow = document.querySelector('.popcoin-buynow');
    if (clickPopBuynow) {
      clickPopBuynow.addEventListener('click', function (e) {
        if (loginFlag.value == 'true') {
          buyNowPopCheckout();
        } else {
          let defaultBuynow = document.querySelector('button[data-testid="Checkout-button"]');
          defaultBuynow.click();
        }
      })
    }
    if (window.location.href.includes('/cart')) {
      openModalFromBottomstripe.style.display = "none";
    }

  } catch (err) {
    console.log(err)
  };
}
$(document).on('click', '.main-bottom .quantity-selector, .main-top button.remove', function () {
  let drawerCheckboxRmv = document.getElementById('buy-with-pop-coins-cart-drawer-checkbox');

  if (drawerCheckboxRmv.checked) {
    drawerCheckboxRmv.checked = false;
  }

})
// PLP Price listing  
const PLPCoins = () => {
  const popClubListing = document.querySelectorAll(".pop-club-listing");
  if (popClubListing.length && popBalance.value) {
    popClubListing.forEach(el => {
      let price = el.getAttribute("price");
      let redeemCoins = Math.round((dataRedeem.value / 100) * price);
      if (redeemCoins > popBalance.value && loginFlag.value == 'true') redeemCoins = popBalance.value;
      if (redeemCoins > 0) {
        let redeemPrice = Math.round(price - redeemCoins);
        let popHTML = "<p>or ₹ " + redeemPrice + ` + <span class='pop-img'><img src='${popIconAPI}'> </span> ` + redeemCoins + "</p>";
        el.innerHTML = popHTML;
      }
      if (redeemCoins == 0) {
        el.style.display = "none";
      }
    })
  }
}

// PDP Earn Call 
const PDPEarnCall = (value) => {
  const PDPEarnDiv = document.querySelector("#pop-club-product-detail");
  let PDPPrice = Math.floor(+PDPEarnDiv?.getAttribute("price").replace(/,/g, ''));
  if (PDPPrice > 1) {
    let modulePrice = PDPPrice % 20;
    let PriceValue = PDPPrice - modulePrice;
    let PDPEarnCoin = Math.round((redeemPrice.value / 100) * PriceValue);
    if (PDPEarnCoin > 0) {
      if (value) PDPEarnCoin = PDPEarnCoin * value;
      popHTML = `<p id='product-issuance-msg'> Earn <span class='pop-img'> <img src='${popIconAPI}'> </span> ` + PDPEarnCoin + " on this product </p>";
      let productIssuanceMsg = document.getElementById("product-issuance-msg");
      if (productIssuanceMsg) {
        PDPEarnDiv.innerHTML = popHTML;
      } else {
        PDPEarnDiv.insertAdjacentHTML("afterbegin", popHTML);
      }
    }
  }
}

// Bottom Bar 
const bottomStrip = (btmcoins) => {
  const popClubStripe = document.getElementById("popcoinBtnSpan");
  const PDPEarnDiv = document.querySelectorAll("#pop-club-product-detail");
  // if(!PDPEarnDiv.length){
  //Home page bottom strip
  if (loginFlag.value == 'true' && popBalance.value > 0) {
    let bottomCoins = popBalance.value;
    let popHTMLStripe = `<span class="rewards-title">TruMoms Rewards </span>Get upto 15% Off using <div class="popcoin_sec"><img width="30" height="30" src="${popIconAPI}">` + bottomCoins + `</div>${popArrowSvg}`;
    popClubStripe.innerHTML = popHTMLStripe;
  }
  // }else{
  //   //PDP page bottom strip
  //   if(loginFlag.value == 'true' && popBalance.value>0){
  //     let PDP_redeemCoins=btmcoins;
  //     if(!btmcoins){
  //       let PDP_Price=Math.floor(+PDPEarnDiv[PDPEarnDiv.length-1]?.getAttribute("price"));
  //       PDP_redeemCoins=Math.round((dataRedeem.value / 100) * PDP_Price);
  //     }
  //     if(PDP_redeemCoins > popBalance.value && loginFlag.value == 'true') PDP_redeemCoins=popBalance.value;
  //     let popHTMLStripe = '<span class="rewards-title">TruMoms Rewards</span>Get upto 30% Off using <div class="popcoin_sec"><img width="30" height="30" src="https://ecomapp-dev-v2.s3.ap-south-1.amazonaws.com/Coin.png">' + PDP_redeemCoins + '</div>';
  //     popClubStripe.innerHTML = popHTMLStripe;
  //   }
  // }
  //Zero balance bottom strip
  if (loginFlag.value == 'true' && popBalance.value == 0) {
    let bottomCoins = popBalance.value;
    let popHTMLStripe = `<div class="popcoin_sec"><img width="30" height="30" src="${popIconAPI}">` + bottomCoins + `</div> | Shop and Earn POPcoins ${popArrowSvg}`;
    popClubStripe.innerHTML = popHTMLStripe;
  }

  if (loginFlag.value == 'false') {
    let bottomCoins = popBalance.value;
    let popHTMLStripe = `<span class="rewards-title">TruMoms Rewards</span> <img src="${popIconAPI}" height="30" width="30" loading="lazy"> Get upto ${dataRedeem.value}% Off using POPcoins ${popArrowSvg}`;
    popClubStripe.innerHTML = popHTMLStripe;
  }

  document.querySelector('button#popcoinsBottomBtn[type="submit"]')?.removeAttribute('type');
}

// PDP Qty Update 
const PDPQtyUpdate = (e) => {
  const PDPEarnDiv = document.querySelectorAll("#pop-club-product-detail");
  let PDP_Price = Math.floor(+PDPEarnDiv[PDPEarnDiv.length - 1]?.getAttribute("price"));
  let PDPQtyVal = Math.round(PDP_Price * e);
  let PDPUpdatedVal = Math.round((dataRedeem.value / 100) * PDPQtyVal);
  // PDPEarnCall(e);
  // bottomStrip(PDPUpdatedVal);
}

// PDP Variant update 
const PDP_PriceContainer = document.querySelector(".product__price .price .price__pricing-group");
const PDP_input_elm = document.querySelector(".product_controls_holder .qtybox #quantity");
const config_pop = {
  childList: true, // observe direct children
  subtree: true, // and lower descendants too
  characterDataOldValue: true // pass old data to callback
}
let observer = new MutationObserver(PDP_VariantChange); //Mutation observer for Price change
if (PDP_PriceContainer) observer.observe(PDP_PriceContainer, config_pop);
function PDP_VariantChange() {
  let VariantPrice;
  let hiddenDiv = PDP_PriceContainer.querySelector('.price__regular');
  if (hiddenDiv) {
    const computedStyle = window.getComputedStyle(hiddenDiv);
    if (computedStyle.display === 'none') {
      VariantPrice = PDP_PriceContainer.querySelector(".price__sale .price-item")?.innerHTML.replace(/ /g, '').replace(/,/g, '').split("Rs.")[1];
    } else {
      VariantPrice = PDP_PriceContainer.querySelector(".price__regular .price-item")?.innerHTML.replace(/ /g, '').replace(/,/g, '').split("Rs.")[1];
    }
  }
  // if(PDP_PriceContainer.querySelector('.price__regular:visible')){
  // VariantPrice=PDP_PriceContainer.querySelector(".price__regular .price-item")?.innerHTML.replace(/ /g,'').replace(/,/g, '').split("Rs.")[1];
  // }else{
  // VariantPrice=PDP_PriceContainer.querySelector(".price__sale .price-item")?.innerHTML.replace(/ /g,'').replace(/,/g, '').split("Rs.")[1];
  // }
  const PDPEarnDiv = document.querySelectorAll("#pop-club-product-detail");
  PDPEarnDiv[PDPEarnDiv.length - 1]?.setAttribute("price", VariantPrice);
  let PDP_Price = Math.floor(+PDPEarnDiv[PDPEarnDiv.length - 1]?.getAttribute("price"));
  let PDPQtyVal = Math.round(PDP_Price * PDP_input_elm?.value);
  let PDPUpdatedVal = Math.round((dataRedeem.value / 100) * PDPQtyVal);
  PDPEarnCall(1);
  // bottomStrip(PDPUpdatedVal); 
  //Varint Id update when Prod changes
  const PDP_Url = window.location.href;
  const PDP_VariantId = PDP_Url.split("variant=")[1];
  const popPDPInput = document.getElementById("pop-club-product-id");
  if (popPDPInput) popPDPInput.value = PDP_VariantId;
}


// PDP Buy Now button 
// const PDP_BuyNow=(loggedIn=false)=>{
//   const defaultBuyNowBtn=document.querySelector(".shopify-payment-button__button");
//   const PopBuyNowBtn=document.querySelector("#shopify-payment-button-popapp");
//   if(loggedIn){
//     defaultBuyNowBtn?.classList.add("hidden");
//     PopBuyNowBtn?.classList.remove("hidden");
//   }else{
//     defaultBuyNowBtn?.classList.remove("hidden");
//     PopBuyNowBtn?.classList.add("hidden");
//   }
// }

// Default Buy now button functionality 
// const buyNowPopCheckout=async()=>{
//   try{
//     const variantId = document.getElementById("pop-club-product-id");
//     const quantity = document.querySelectorAll(".quantity .quantity__input");
//     if(quantity.length == 0){
//       const buyNowparam = `?variant=${variantId?.value}&shop=${Shopify.shop}&key=${key}&quantity=${1}`;
//       const buyNowUrl=`https://prodreplica.mypopcoins.com/api/get-coins${buyNowparam}`;
//       const resp=await fetch(buyNowUrl);
//       const data=await resp.json();
//       const originalString = data.url;
//       const findString = 'https://polishmeprettyindia.myshopify.com';
//       const replaceString = 'https://www.polishmepretty.in';
//       const updatedString = originalString.replace(findString, replaceString);
//       data.success==true?window.location = updatedString:openModel();  
//     }else{
//       const buyNowparam = `?variant=${variantId?.value}&shop=${Shopify.shop}&key=${key}&quantity=${quantity[quantity.length-1]?.value}`;
//       const buyNowUrl=`https://prodreplica.mypopcoins.com/api/get-coins${buyNowparam}`;
//       const resp=await fetch(buyNowUrl);
//       const data=await resp.json();
//       const originalString = data.url;
//       const findString = 'https://polishmeprettyindia.myshopify.com';
//       const replaceString = 'https://www.polishmepretty.in';
//       const updatedString = originalString.replace(findString, replaceString);
//       data.success==true?window.location = updatedString:openModel();
//     }
//   }catch(err){
//     console.log(err);
//   }
// }
// let customBuy = document.querySelector('.custom-buy');
// if(customBuy){
//   customBuy.addEventListener('click',function(e){
//     e.preventDefault();
//     if(loginFlag.value == 'true'){
//       buyNowPopCheckout();
//     }else{
//       $('button[data-testid="Checkout-button"]').click();
//     }
//   })
// }
// //Third party buy now button functionality
// const customBuyNowCheckout=async()=>{
//   try{
//   const PDPPrice=document.querySelector('#pop-club-product-detail')?.getAttribute('price');
//   const quantity = document.querySelectorAll(".quantity .quantity__input");
//   let finalPDPPrice=(+PDPPrice)*(+quantity[quantity.length-1]?.value);
//   const variantId = document.getElementById("pop-club-product-id");
//   const buyNowparam = `?cart=${finalPDPPrice}&shop=${Shopify.shop}&key=${key}&variants=${variantId?.value}`;
//   const buyNowUrl=`https://prodreplica.mypopcoins.com/api/get-coins-cart-discount${buyNowparam}`;
//   const resp=await fetch(buyNowUrl);
//   const data=await resp.json();
//   let now = new Date();
//   let time = now.getTime();
//   time += 3600 * 1000;
//   now.setTime(time);
//   document.cookie = `discount_code=${data.code};expires=${now.toUTCString()};path=/`;
//   }catch(err){
//     console.log(err)
//   }
// }

//Clear discounts from cookies
const discount_clear = () => {
  remove_discount();
  document.cookie = 'discount_code=; expires=Thu, 18 Dec 2020 12:00:00 UTC; path=/';
}

//Calculating cart value
const popSubtotal = async (data) => {

  const popMaxRedeem = parseInt(sessionStorage.getItem('popMaxRedeem'));
  let popHTML = "Calculating your total cart value";
  const popCoinLabel = document.querySelectorAll("#buy-with-pop-coins-cart-drawer-label");
  const popCoinCheckbox = document.querySelectorAll("#buy-with-pop-coins-cart-drawer-checkbox");
  const subtotalValue = document.querySelectorAll(".footer-row .slidecart-subtotal");

  const popCartPriceVal = data['items_subtotal_price'] / 100, popMOV = parseInt(sessionStorage.getItem('popMOV'));

  if (popCartPriceVal < popMOV) {
    popCoinCheckbox.forEach(el => el.style.display = 'none');
    popCoinLabel.forEach(el => el.style.display = "block");
    popHTML = `<div style="display: flex; align-items: center; font-size: 14px;"><img src="${popIconAPI}" height="25px" width="25px" style="height: 25px; width: 25px"> coins valid on orders above Rs. ${popMOV}</div>` + lottieAnimation;
  }
  else if (loginFlag.value == 'true') {
    let priceLength = (data['items_subtotal_price'].toString().length) - 2;
    let price = data['items_subtotal_price'].toString().slice(0, priceLength);
    let redeemCoins = Math.min(Math.round((dataRedeem.value / 100) * price), popMaxRedeem);
    if (redeemCoins > popBalance.value && loginFlag.value == 'true') redeemCoins = popBalance.value;
    let redeemPrice = Math.round(price - redeemCoins);
    let totalPrice = `${redeemPrice.toLocaleString()}.00`;
    let cartPrice = `${price.toLocaleString()}.00`;
    if (redeemCoins == 0) {
      // popCoinCheckbox.forEach(el=>el.classList.add("hidden"));
      popCoinLabel.forEach(el => el.style.display = "block");
      popCoinCheckbox.forEach(el => el.style.display = 'none');
      popCoinCheckbox.forEach(el => el.checked = false);
      popHTML = 'You have 0 POPcoins. Shop now & earn coins' + lottieAnimation;
      subtotalValue.forEach(el => el.innerHTML = "Rs. " + totalPrice);
    } else {
      popCoinLabel.forEach(el => el.style.display = "flex");
      popCoinCheckbox.forEach(el => el.style.display = 'block');
      popCoinCheckbox[0].checked ? popHTML = `Rs. ${redeemCoins} | Saved using <img src="${popIconAPI}" style="height: 25px; width: 25px;" />coins` + lottieAnimation : popHTML = `Save Rs. ${redeemCoins} using <img src="${popIconAPI}" style="height: 25px; width: 25px;" />coins` + lottieAnimation;
      popCoinCheckbox[0].checked ? subtotalValue.forEach(el => el.innerHTML = `Rs. ${totalPrice}`) : subtotalValue.forEach(el => el.innerHTML = `Rs. ${cartPrice}`)
    }
  } else {
    popCoinCheckbox.forEach(el => el.style.display = 'none');
    popCoinLabel.forEach(el => el.style.display = "flex");
    popHTML = `<span class="underline"><strong><u>Click</u></strong> & get upto ${dataRedeem.value}% off using <img src="${popIconAPI}" style="height: 25px; width: 25px;" />coins</span>` + lottieAnimation;
  }
  popCoinLabel.forEach(el => el.innerHTML = popHTML);
  if ($('.discount-allocations').length != 0) {
    popCoinCheckbox.forEach(el => el.style.display = 'none');
    popCoinLabel.forEach(el => el.style.display = "none");
    popCoinCheckbox[0].checked = false;
    popCoinCheckbox[0].checked ? subtotalValue.forEach(el => el.innerHTML = `Rs. ${totalPrice}`) : subtotalValue.forEach(el => el.innerHTML = `Rs. ${cartPrice}`)
  }
  data['items'].forEach(function (el) {
    if (el['product_type'] == "BYOB") {
      popCoinCheckbox.forEach(el => el.style.display = 'none');
      popCoinLabel.forEach(el => el.style.display = "none");
    }
  })
}

//Creating elem
function create(el) {
  var d = document;
  var element = d.createElement(el);
  element.classList.add("manual-class");
  return element;
}

//Cart Earn Call
const cartEarnCall = async () => {
  try {
    const CartItemList = document.querySelectorAll(".slidecarthq .items .item");
    function insertAfter(newNode, existingNode) { //Creates Earn call elem
      return new Promise((res, rej) => {
        res(existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling));
      })
    }
    const resp = await fetch(window.Shopify.routes.root + 'cart.js')
    var data = await resp.json();
    let i = 0;
    if (CartItemList.length) {
      CartItemList.forEach(el => {
        let BYOB = el.querySelector('.main .main-top .main-top-left ul.properties-key-value li:nth-child(2) .properties-key-value-value');
        if (BYOB) {
          if (BYOB.textContent == 'BYOB') {
          }
        } else {
          if (data['items'].length) {
            let priceLength = (data['items'][i].final_price.toString().length) - 2;
            let quantity = data['items'][i].quantity;
            let price = data['items'][i].final_price.toString().slice(0, priceLength) + "." + data['items'][i].price.toString().slice(priceLength);
            if (price == ".0") {
              let val = document.querySelectorAll(".CartItem__Price")[i].textContent.split(",").join("").split(" ")[1];
              price = val;
              i++;
            }
            let priceValue = Math.floor(price);
            let roundedPrice = 0;
            if (priceValue.toString().length >= 2) {
              let modulePrice = priceValue % 20;
              roundedPrice = priceValue - modulePrice;
            }
            let issueCoins = Math.round(((redeemPrice.value / 100) * roundedPrice) * quantity);
            if (issueCoins > 0) {
              let newstring = `<p id='product-issuance-msg'> Earn <span class='pop-img'> <img src='${popIconAPI}' width='20' height='21'> </span> ` + issueCoins + "</p>";
              if (el.querySelector(".main .manual-class") != null) {
                el.querySelectorAll(".manual-class").forEach((old_item) => {
                  old_item.remove();
                });
              }
              const ex = el.querySelector(".main");
              if (ex) {
                insertAfter(create("div"), el.querySelector(".main .main-bottom")).then(() => {
                  el.querySelector(".main .manual-class").innerHTML = newstring;
                })
                i++;
              }
            }
          }
        }
        // data['items'].forEach(function(el1){
        //   if(el1['product_type'] == "BYOB"){
        //     el.querySelector(".main .manual-class").style.display="none";
        //   }
        // })
      })
    }
  } catch (err) {
    console.log(err)
  } finally {
    popSubtotal(data)
  }
}
const cartPagepopSubtotal = async (data) => {

  const popMaxRedeem = parseInt(sessionStorage.getItem('popMaxRedeem'));
  const popCartPriceVal = data['items_subtotal_price'] / 100, popMOV = parseInt(sessionStorage.getItem('popMOV'));

  let popHTML = "Calculating your total cart value";
  const popCoinLabel = document.querySelectorAll("#buy-with-pop-coins-cart-page-label");
  const popCoinCheckbox = document.querySelectorAll("#buy-with-pop-coins-cart-page-checkbox");
  const subtotalValue = document.querySelectorAll(".cart-subtotal .cart-subtotal__price");

  if (popCartPriceVal < popMOV) {
    popCoinCheckbox.forEach(el => el.style.display = 'none');
    popCoinLabel.forEach(el => el.style.display = "block");
    popHTML = `<div style="display: flex; align-items: center; font-size: 14px;"><img src="${popIconAPI}" height="25px" width="25px" style="height: 25px; width: 25px"> coins valid on orders above Rs. ${popMOV}</div>` + lottieAnimation;
  }
  else if (loginFlag.value == 'true') {
    let priceLength = (data['items_subtotal_price'].toString().length) - 2;
    let price = data['items_subtotal_price'].toString().slice(0, priceLength);
    let redeemCoins = Math.min(Math.round((dataRedeem.value / 100) * price), popMaxRedeem);
    if (redeemCoins > popBalance.value && loginFlag.value == 'true') redeemCoins = popBalance.value;
    let redeemPrice = Math.round(price - redeemCoins);
    let totalPrice = `${redeemPrice.toLocaleString()}.00`;
    let cartPrice = `${price.toLocaleString()}.00`;
    if (redeemCoins == 0) {
      // popCoinCheckbox.forEach(el=>el.classList.add("hidden"));
      popCoinCheckbox.forEach(el => el.style.display = 'none');
      popCoinCheckbox.forEach(el => el.checked = false);
      popHTML = 'You have 0 POPcoins. Shop now & earn coins' + lottieAnimation;
      subtotalValue.forEach(el => el.innerHTML = "Rs. " + totalPrice);
    } else {
      popCoinCheckbox.forEach(el => el.style.display = 'block');
      popCoinCheckbox[0].checked ? popHTML = `Rs .${redeemCoins} | Saved using <img src="${popIconAPI}" style="height: 25px; width: 25px;" />coins` + lottieAnimation : popHTML = `Save Rs. ${redeemCoins} using <img src="${popIconAPI}" style="height: 25px; width: 25px;" />coins` + lottieAnimation;
      popCoinCheckbox[0].checked ? subtotalValue.forEach(el => el.innerHTML = `Rs. ${totalPrice}`) : subtotalValue.forEach(el => el.innerHTML = `Rs. ${cartPrice}`)
    }
  } else {
    popCoinCheckbox.forEach(el => el.style.display = 'none');
    popHTML = `<span class="underline" onclick="openModel()"><strong><u>Click</u></strong> & get upto ${dataRedeem.value}% off using <img src="${popIconAPI}" style="height: 25px; width: 25px;" />coins</span>` + lottieAnimation;
  }
  popCoinLabel.forEach(el => el.innerHTML = popHTML);
  data['items'].forEach(function (el) {
    if (el['product_type'] == "BYOB") {
      popCoinCheckbox.forEach(el => el.style.display = 'none');
      popCoinLabel.forEach(el => el.style.display = "none");
    }
  })
}
//CartPage Earn Call
const cartPageEarnCall = async () => {
  try {
    const CartItemList = document.querySelectorAll("tbody .cart__row");
    function insertAfter(newNode, existingNode) { //Creates Earn call elem
      return new Promise((res, rej) => {
        res(existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling));
      })
    }
    const resp = await fetch(window.Shopify.routes.root + 'cart.js')
    var data = await resp.json();
    let i = 0;
    if (CartItemList.length) {
      CartItemList.forEach(el => {
        if (data['items'].length) {
          let BYOB = el.querySelector('.cart__product-title');
          if (BYOB.textContent.includes('Build Your Own Bundle')) {
          } else {
            let priceLength = (data['items'][i].final_price.toString().length) - 2;
            let quantity = data['items'][i].quantity;
            let price = data['items'][i].final_price.toString().slice(0, priceLength) + "." + data['items'][i].price.toString().slice(priceLength);
            if (price == ".0") {
              let val = document.querySelectorAll(".CartItem__Price")[i].textContent.split(",").join("").split(" ")[1];
              price = val;
              i++;
            }
            let priceValue = Math.floor(price);
            let roundedPrice = 0;
            if (priceValue.toString().length >= 2) {
              let modulePrice = priceValue % 20;
              roundedPrice = priceValue - modulePrice;
            }
            let issueCoins = Math.round(((redeemPrice.value / 100) * roundedPrice) * quantity);
            if (issueCoins > 0) {
              let newstring = `<p id='product-issuance-msg'> Earn <span class='pop-img'> <img src='${popIconAPI}' width='20' height='21'> </span> ` + issueCoins + "</p>";
              if (el.querySelector(".cart__product-information .manual-class") != null) {
                el.querySelectorAll(".manual-class").forEach((old_item) => {
                  old_item.remove();
                });
              }
              const ex = el.querySelector(".cart__product-information");
              if (ex) {
                insertAfter(create("div"), el.querySelector(".cart__product-information .popcoin-page")).then(() => {
                  el.querySelector(".cart__product-information .manual-class").innerHTML = newstring;
                })
                i++;
              }
            }
          }
        }
      })
    }
  } catch (err) {
    console.log(err);
  } finally {
    cartPagepopSubtotal(data);
  }
}
// Cart Default checkout 
const cartPopCheckout = async () => {
  try {
    const resp = await fetch(window.Shopify.routes.root + 'cart.js')
    const data = await resp.json();
    let priceLength = (data['items_subtotal_price'].toString().length) - 2;
    let price = data['items_subtotal_price'].toString().slice(0, priceLength) + "." + data['items_subtotal_price'].toString().slice(priceLength);
    let variants = '';
    for (let i = 0; i < data['items'].length; i++) {
      variants += data['items'][i]['variant_id'] + '-' + data['items'][i]['quantity'] + ',';
    }
    let cartParams = `?cart=${price}&shop=${Shopify.shop}&key=${key}&variants=${variants}`;
    const cartUrl = `https://prodreplica.mypopcoins.com/api/get-coins-cart${cartParams}`;
    const pop_resp = await fetch(cartUrl);
    const pop_data = await pop_resp.json();
    const originalString = pop_data.url;
    const findString = 'https://polishmeprettyindia.myshopify.com';
    const replaceString = 'https://www.polishmepretty.in';
    const updatedString = originalString.replace(findString, replaceString);
    pop_data.success == true ? window.location = updatedString : openModel();
  } catch (err) {
    console.log(err)
  }
}
async function remove_discount() {
  try {
    let key = document.cookie.split('; ').find((row) => row.startsWith('_shopify_s='))?.split('=')[1];
    let parameters1 = '&shop=' + Shopify.shop + '&key=' + key;
    const response = await fetch('https://prodreplica.mypopcoins.com/api/remove-discount-code?' + parameters1).then((response) => response.json()).then(data => {
      if (data.success) {
        console.log("discount_deleted");
      }
    })
  } catch (err) {
    console.log(err)
  }
}
// function getCookie(name) {
//     const value = "; " + document.cookie;
//     const parts = value.split("; " + name + "=");
//     if (parts.length === 2) return parts.pop().split(";").shift();
//     return null; // or return undefined
// }
// let cartPopCheckoutButton = document.querySelector('.custom-chckout')
// if(cartPopCheckoutButton){
//   cartPopCheckoutButton.addEventListener('click',function(e){
//     e.preventDefault();
//     let cartPageCheckbox = document.getElementById('buy-with-pop-coins-cart-page-checkbox');
//     if(cartPageCheckbox.checked == true){
//       window.location.href= "/checkout?discount=" + getCookie('discount_code');
//     }else{
//       let defaultCheckoutButton = document.querySelector('.default-checkout');
//       defaultCheckoutButton.click();
//     }
//   })
// }
// let cartPopNotiCheckoutButton = document.querySelector('.drawer-custom')
// if(cartPopNotiCheckoutButton){
//   cartPopNotiCheckoutButton.addEventListener('click',function(e){
//     e.preventDefault();
//     let cartDrawerCheckboxNoti = document.getElementById('buy-with-pop-coins-cart-drawer-checkbox');
//     if(cartDrawerCheckboxNoti.checked == true){
//        window.location.href= "/checkout?discount=" + getCookie('discount_code');
//     }else{
//       let defaultCheckoutButtonNoti = document.querySelector('.drawer-default');
//       defaultCheckoutButtonNoti.click();
//     }
//   })
// }
//Updating Cart discount
const updateCartPopPrice = (e) => {
  const checkbox = document.querySelectorAll("#buy-with-pop-coins-cart-drawer-checkbox");
  checkbox.forEach(el => el.checked = e.target.checked);
  cartEarnCall();
  // const check_spinner=document.querySelector(".lds-dual-ring");
  // const check_btn=document.querySelector(".checkout_text");
  if (e.target.checked) {
    if (check_btn) check_btn.style.display = "none";
    if (check_spinner) check_spinner.style.display = "block";
    // customCartCheckout();
    cartPopCheckout();
  } else {
    discount_clear();
  }
}

// Cart third party checkout
const customCartCheckout = async () => {
  try {
    const simpl_btns = document.querySelectorAll("magic-checkout-btn");
    const checkBOxDrawer = document.getElementById('buy-with-pop-coins-cart-drawer-checkbox');
    checkBOxDrawer.style.pointerEvents = "none";
    simpl_btns.forEach(el => el.style.pointerEvents = "none");
    simpl_btns.forEach(el => el.style.opacity = "0.5");
    // const simpl_btns2 = document.querySelectorAll('.drawer-custom');
    // simpl_btns2.forEach(el => el.disabled = true);
    const resp = await fetch(window.Shopify.routes.root + 'cart.js')
    const data = await resp.json();
    let priceLength = (data['items_subtotal_price'].toString().length) - 2;
    let price = data['items_subtotal_price'].toString().slice(0, priceLength) + "." + data['items_subtotal_price'].toString().slice(priceLength);
    let variants = '';
    for (let i = 0; i < data['items'].length; i++) {
      variants += data['items'][i]['variant_id'] + '-' + data['items'][i]['quantity'] + ',';
    }
    let cartParams = `?cart=${price}&shop=${Shopify.shop}&key=${key}&variants=${variants}`;
    const cartUrl = `https://prodreplica.mypopcoins.com/api/get-coins-cart-discount${cartParams}`;
    console.log(cartUrl, 'cartUrl');
    const pop_resp = await fetch(cartUrl);
    const pop_data = await pop_resp.json();
    let now = new Date();
    let time = now.getTime();
    time += 3600 * 1000;
    now.setTime(time);
    document.cookie = `discount_code=${pop_data.code};expires=${now.toUTCString()};path=/`;
    setTimeout(function () {
      // const simpl_btns = document.querySelectorAll(".custom-chckout");
      simpl_btns.forEach(el => el.style.pointerEvents = "all");
      simpl_btns.forEach(el => el.style.opacity = "1");
      checkBOxDrawer.style.pointerEvents = "all";

      // simpl_btns2.forEach(el => el.disabled = false);
    }, 2000);
  } catch (err) {
    console.log(err)
  }
}

//Open loaded iframe
let modal = document.getElementById('popcoinsIframeModal');
function openModel() {
  modal.style.display = 'block';
  document.body.classList.add('popcoinShow');
}
let popcoinsModalCloseBtn = document.getElementById('popcoinsModalCloseBtn');
popcoinsModalCloseBtn.addEventListener("click", function () {
  modal.style.display = "none";
  document.body.classList.remove("body", "popcoinShow");
  getBrandInfo();
});
let openModalFromBottomstripe = document.getElementById('popcoinsBottomBtn');
openModalFromBottomstripe.addEventListener('click', function () {
  setTimeout(function () {

    // openModel();
    if (document.querySelector("#popcoinsIframe").src.toString().includes('-cart') == true) {
      preLoadIframe(false);
      openModel();
    }
    else {
      // preLoadIframe();
      openModel();
    }
  }, 700);

})
/* preload iframe */
function preLoadIframe(isCart = false) {
  let key = document.cookie
    .split('; ')
    .find((row) => row.startsWith('_shopify_s='))
    ?.split('=')[1];
  let modals = document.getElementById("popcoinsIframeModal");
  modals.style.opacity = 1;
  document.body.classList.add('popcoinShow');

  let refUrl = new URLSearchParams(document.location.search);
  refUrl = refUrl.get('ref');

  if (refUrl === null) {
    if (sessionStorage.getItem('lastPopReferred') !== null) {
      refUrl = sessionStorage.getItem('lastPopReferred');
    }
  }
  else {
    sessionStorage.setItem('lastPopReferred', refUrl);
  }

  if (window.location.href.indexOf("/products/") != -1) {
    var redeemPrices = document.getElementById("pop-club-redeem-price").value;
    let redeemCoins = redeemPrices;
    let iframeURL = document.getElementById("pop-club-iframe-url").value;
    document.getElementById('popcoinsIframe').src = iframeURL + "&key=" + key + "&page=pdp&discount=" + redeemCoins + '&url=' + window.location.href + ((isCart) ? '-cart' : '') + ((refUrl !== null) ? '&ref=' + refUrl : '');
  } else {
    let cartPage = "";
    if (window.location.href.indexOf("/cart") != -1) {
      cartPage = "&page=cart";
    }
    let iframeURL = document.getElementById("pop-club-iframe-url").value;
    document.getElementById('popcoinsIframe').src = iframeURL + "&key=" + key + cartPage + '&url=' + window.location.href + ((isCart) ? '-cart' : '') + ((refUrl !== null) ? '&ref=' + refUrl : '');
  }
  console.log("iframe loaded");
  body.removeEventListener("mousemove", loadIframe);
  body.removeEventListener("touchstart", loadIframe);
}
const body = document.querySelector("body");
function loadIframe() {
  setTimeout(function () {
    preLoadIframe();
  }, 100)
}

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(function () {
    getBrandInfo();
    addPopcoinsInMenu()
  }, 200);
})
body.addEventListener("mousemove", loadIframe);
body.addEventListener("touchstart", loadIframe);

function addPopcoinsInMenu() {
  // if($('.popcoinsMenu').length == 0){
  // desktop menu
  let desktop_nav = document.querySelector("#AccessibleNav .site-nav");
  let li_menu = document.createElement("li");
  li_menu.setAttribute("class", "popcoinsMenu site-nav--active");

  let menu = document.createElement("a");
  menu.setAttribute(
    "class",
    "site-nav__link site-nav__link--main text-decoration-none site-nav__link--active"
  );
  menu.setAttribute("onclick", "openModel()");

  let menuSpan = document.createElement("span");
  menuSpan.setAttribute(
    "class",
    "site-nav__label border-0 fw-700 text-white font-s-20"
  );
  menuSpan.innerHTML = rewardNameLottieAnimationLink;
  menu.appendChild(menuSpan);
  li_menu.appendChild(menu);
  desktop_nav.appendChild(li_menu);
  // }
  // mobile menu

  let mobile_nav = document.querySelector(".mobile-nav-wrapper #MobileNav");
  let mobile_li_menu = document.createElement("li");
  mobile_li_menu.setAttribute("class", "popcoinsMenu mobile-nav__item demo");

  let menu_mob = document.createElement("a");
  menu_mob.setAttribute(
    "class",
    "mobile-nav__link text-decoration-none mobile-nav__link--active"
  );
  menu_mob.setAttribute("onclick", "openModel()");

  let menuSpan_mob = document.createElement("span");
  menuSpan_mob.setAttribute(
    "class",
    "mobile-nav__label"
  );
  menuSpan_mob.innerHTML = rewardNameLottieAnimationLink;
  menu_mob.appendChild(menuSpan_mob);
  mobile_li_menu.appendChild(menu_mob);
  mobile_nav.appendChild(mobile_li_menu);
  const listItems = mobile_nav.getElementsByTagName('li');
  const secondLastListItem = listItems[listItems.length - 10];
  if (secondLastListItem) {
    // Append the new list item to the second-to-last list item
    secondLastListItem.insertAdjacentElement('afterend', mobile_li_menu);
  }
}
setTimeout(function () {
  if (window.location.href.includes('/cart')) { } else {
    let popCoinDrawer = document.querySelector('.popcoinsConfiguration');
    let toLocation = document.querySelector('.sticky-footer .footer-row')
    if (toLocation) {
      toLocation.parentNode.insertBefore(popCoinDrawer, toLocation);
      // }
      let cartDrawerLabel = document.getElementById('buy-with-pop-coins-cart-drawer-label')
      cartDrawerLabel.addEventListener('click', function () {
        if (loginFlag.value == 'false') {
          if (document.querySelector("#popcoinsIframe").src.toString().includes('-cart') == false) {
            preLoadIframe(true);
            openModel();
          }
          else {
            openModel();
          }

        }
      })
    }
  }
}, 3000);
window.SLIDECART_UPDATED = function (cart) {
  getBrandInfo();
}
window.SLIDECART_LOADED = function (cart) {
  getBrandInfo();
}
window.SLIDECART_OPENED = function () {
  // Fires whenever Slide Cart has been opened
  $('.popcoins-bottom-btn').hide();
  if (window.location.href.includes('/cart')) {
    let popCoinDrawer = document.querySelector('.custom-html .popcoinsConfiguration');
    let toLocation = document.querySelector('.sticky-footer .footer-row')
    if (toLocation) {
      toLocation.parentNode.insertBefore(popCoinDrawer, toLocation);
      // }
      let cartDrawerLabel = document.getElementById('buy-with-pop-coins-cart-drawer-label')
      cartDrawerLabel.addEventListener('click', function () {
        if (loginFlag.value == 'false') {
          if (document.querySelector("#popcoinsIframe").src.toString().includes('-cart') == false) {
            preLoadIframe(true);
            openModel();
          }
          else {
            // preLoadIframe();
            openModel();
          }

        }
      })
    }
  } else {
    let popCoinDrawer = document.querySelector('.popcoinsConfiguration');
    let toLocation = document.querySelector('.sticky-footer .footer-row')
    if (toLocation) {
      toLocation.parentNode.insertBefore(popCoinDrawer, toLocation);
      // }
      let cartDrawerLabel = document.getElementById('buy-with-pop-coins-cart-drawer-label')
      cartDrawerLabel.addEventListener('click', function () {
        if (loginFlag.value == 'false') {
          if (document.querySelector("#popcoinsIframe").src.toString().includes('-cart') == false) {
            preLoadIframe(true);
            openModel();
          }
          else {
            // preLoadIframe();
            openModel();
          }

        }
      })
    }
  }
  if ($('.footer-code').length != 0) {
    const popCoinLabel1 = document.querySelectorAll("#buy-with-pop-coins-cart-drawer-label");
    const popCoinCheckbox1 = document.querySelectorAll("#buy-with-pop-coins-cart-drawer-checkbox");
    popCoinCheckbox1.forEach(el => el.style.display = 'none');
    popCoinCheckbox1.forEach(el => el.checked = false);
    popCoinLabel1.forEach(el => el.style.display = "none");
  }
}
window.SLIDECART_CLOSED = function () {
  // Fires whenever Slide Cart has been closed
  $('.popcoins-bottom-btn').show();
}
$(document).on('click', '.header_menu_icon', function () {
  if ($('.show-menu-pop').length == 0) {
    $('body').addClass('show-menu-pop');
  } else {
    $('body').removeClass('show-menu-pop');
  }
})
$(document).on('click', '.discount-box-form button', function () {
  const popCoinLabel = document.querySelectorAll("#buy-with-pop-coins-cart-drawer-label");
  const popCoinCheckbox = document.querySelectorAll("#buy-with-pop-coins-cart-drawer-checkbox");
  popCoinCheckbox.forEach(el => el.checked = false);
  getBrandInfo();
  setTimeout(function () {
    if ($('.footer-code').length != 0) {
      popCoinCheckbox.forEach(el => el.style.display = 'none');
      popCoinLabel.forEach(el => el.style.display = "none");
    }
  }, 5500)
})
$(document).on('click', '.footer-code button', function () {
  setTimeout(function () {
    const popCoinLabel12 = document.querySelectorAll("#buy-with-pop-coins-cart-drawer-label");
    const popCoinCheckbox12 = document.querySelectorAll("#buy-with-pop-coins-cart-drawer-checkbox");
    if ($('.footer-code').length != 0) {
      if (loginFlag.value == 'true') {
        popCoinCheckbox12.forEach(el => el.style.display = 'none');
        popCoinLabel12.forEach(el => el.style.display = "none");
      } else {
        popCoinLabel12.forEach(el => el.style.display = "none");
      }
      popCoinCheckbox12.forEach(el => el.checked = false);
    } else {
      if (loginFlag.value == "true") {
        popCoinCheckbox12.forEach(el => el.style.display = 'block');
        popCoinLabel12.forEach(el => el.style.display = "block");
      } else {
        popCoinLabel12.forEach(el => el.style.display = "block");
      }
      popCoinCheckbox12.forEach(el => el.checked = true);
    }
    getBrandInfo()
  }, 5500);
})